export class DeviceDetector {
    public static isMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(
        navigator.userAgent.toLowerCase()
    );

    public static isPortrait = window.matchMedia('(orientation: portrait)').matches;

    public static innerHeight = Object.freeze(innerHeight + 100);

    public static isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    public static isPortraitIOS = () => !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    public static isIOs = () => /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);

    public static isFireFox = () => navigator.userAgent.search('Firefox') > -1;

    public static isInternetExplorer =
        window.navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./);
}
